import { render, staticRenderFns } from "./ColumnsContent.vue?vue&type=template&id=5c2cccf2&scoped=true"
import script from "./ColumnsContent.vue?vue&type=script&lang=js"
export * from "./ColumnsContent.vue?vue&type=script&lang=js"
import style0 from "./ColumnsContent.vue?vue&type=style&index=0&id=5c2cccf2&prod&lang=scss"
import style1 from "./ColumnsContent.vue?vue&type=style&index=1&id=5c2cccf2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c2cccf2",
  null
  
)

export default component.exports